import { api } from '../client';

export type OverheadKind = 'utilities_per_kg' | 'packaging_per_pack' | 'partner_utilities_per_kg';

/**
 * Production overhead rate: utilities per kg or packaging per pack (owner 2026-10-04);
 * partner_utilities_per_kg is the utilities rate inside Four People prices (owner 2026-11-03).
 */
export interface OverheadRate {
  id: string;
  kind: OverheadKind;
  category_id: string | null;
  category_name: string | null;
  rate: string;
  scope: 'default' | 'category';
  updated_at: string | null;
}

export function createStockOverheadRatesApi() {
  return {
    list: (): Promise<{ request_id: string; rates: OverheadRate[] }> =>
      api.webAdmin.get('/stock/overhead-rates'),

    upsertDefault: (kind: OverheadKind, rate: string): Promise<{ rate: OverheadRate }> =>
      api.webAdmin.put(`/stock/overhead-rates/${kind}/default`, { rate }),

    upsertCategory: (
      kind: OverheadKind,
      categoryId: string,
      rate: string,
    ): Promise<{ rate: OverheadRate }> =>
      api.webAdmin.put(`/stock/overhead-rates/${kind}/category/${categoryId}`, { rate }),

    delete: (rateId: string): Promise<{ request_id: string; success: boolean }> =>
      api.webAdmin.delete(`/stock/overhead-rates/${rateId}`),
  };
}
